import { type FC, type MouseEventHandler } from 'react';
import type { IconName } from 'src/common/components/icon';
import { Icon } from 'src/common/components/icon';
import { useOpenModal } from 'src/common/components/next-modal';
import { Tooltip } from 'src/common/components/tooltip';
import { publicLink } from 'src/common/const';
import { IconUiSizeBox } from 'src/components/icon-ui-size-box';
import { SpaceCapacity } from 'src/components/space-capacity';
import { Modals } from 'src/modals';
import { bizTracker } from 'src/utils/biz-tracker';
import { ResourceCenter } from '../resource-center';
import { TrashPopup } from './trash';
import { Images } from 'src/image';

export const AsideFooter: FC<{}> = () => {
  const renderList = [
    {
      title: '知识库广场',
      popup: '前往知识库广场',
      click: () => {
        bizTracker.event('knowledge', { is_from: 'cata_knowledge' });
        window.open(__BUILD_IN__ ? publicLink.market : publicLink.subscribeCenter);
      },
      icon: 'IcKnowledgeBase',
      hidden: __PRIVATE__,
    },
  ].filter((i) => !i.hidden);
  const onClick = () => {
    bizTracker.event('knowledge', { is_from: 'cata_knowledge' });
    window.open(__BUILD_IN__ ? publicLink.market : publicLink.subscribeCenter);
  };
  return (
    <div className="mt-auto">
      <SpaceCapacity type="aside" />
      <div
        className="grid text-t3-medium py-2 gap-2 px-2"
        style={{
          gridTemplateColumns: `repeat(${renderList.length}, minmax(0, 1fr))`,
        }}
      >
        <Tooltip
          className="relative flex text-t3-medium items-center animate-hover-black3 space-x-2 px-1 py-2"
          popup="前往知识库广场"
          onClick={onClick}
          placement="top"
        >
          {/* <Icon className="text-grey3" name={item.icon as IconName} size="middle" /> */}
          <img src={Images.templateEmpty}></img>

          <span className="text-grey2">知识库广场</span>
        </Tooltip>
      </div>
    </div>
  );
};

export const AsideFooterToolList = () => {
  const openModal = useOpenModal();

  const openTemplateCenter = () => {
    openModal.modal({
      modalId: Modals.TEMPLATE_CENTER,
      content: () => <ResourceCenter from="quickSetting" />,
    });
  };

  const handleOpenTrash: MouseEventHandler = (event) => {
    bizTracker.event('recycle_click');
    openModal.dropdown({
      modalId: Modals.TRASH,
      popcorn: event.currentTarget,
      placement: 'right',
      content: () => <TrashPopup />,
    });
  };

  return (
    <div className="px-2">
      {[
        // 模板中心移到回收站上方
        {
          title: '模板中心',
          popup: '社区精选模板',
          click: openTemplateCenter,
          icon: 'IcTemplate',
          hidden: __PRIVATE__,
        },
        {
          title: '回收站',
          popup: '删除的页面及文件',
          click: handleOpenTrash,
          icon: 'IcTrash',
        },
      ]
        .filter((item) => !item.hidden)
        .map((item) => (
          <Tooltip
            className="text-grey3 h-8 flex items-center text-t2-medium px-2.5 animate-hover animate-click space-x-1"
            key={item.title}
            onClick={item.click}
          >
            <IconUiSizeBox size={20}>
              <Icon size="small" name={item.icon as IconName} />
            </IconUiSizeBox>
            <div>{item.title}</div>
          </Tooltip>
        ))}
    </div>
  );
};
